module.exports = __webpack_public_path__ + "static/media/icon_started_extra_timedba169e72277c8bccc9575b0f1499672.webp";